export default __webpack_public_path__ + "static/media/brand12.0afa74d0.svg";